export function KewagBadge() {
  return (
    <a
      id="kewagpage-badge"
      data-testid="kewagpage-badge"
      href="https://kewagpage.ch/"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-4 right-4 z-[9999] inline-flex h-10 items-center gap-2 rounded-full bg-black px-4 no-underline shadow-lg"
    >
      <img src="/kewagpage-icon.png" alt="KEWAGpage" className="block h-[18px] w-[18px] object-contain" />
      <span className="m-0 whitespace-nowrap text-[13px] font-semibold leading-5 text-white" style={{ fontFamily: "Inter, sans-serif" }}>
        Made with KEWAGpage
      </span>
    </a>
  );
}
